export enum SocialMediaAccountType {
  Facebook = 1,
  Instagram = 2,
  TikTok = 3,
  X = 4,
  YouTube = 5,
  WhatsApp = 6,
  Snapchat = 7,
  Pinterest = 8
}
